import { render, staticRenderFns } from "./ConfigurationManager.vue?vue&type=template&id=40a8ef72&"
import script from "./ConfigurationManager.vue?vue&type=script&lang=js&"
export * from "./ConfigurationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a8ef72')) {
      api.createRecord('40a8ef72', component.options)
    } else {
      api.reload('40a8ef72', component.options)
    }
    module.hot.accept("./ConfigurationManager.vue?vue&type=template&id=40a8ef72&", function () {
      api.rerender('40a8ef72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/configurationManager/ConfigurationManager.vue"
export default component.exports